import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IBoxDevice, IDeviceClassLoookupField, IMenu } from "../interfaces";

export type MegaMenuItemType = "analytics" | "modules" | "admin" | "";

type NavigationStoreType = {
  activeHref: string;
  activeMenuItem: IMenu | undefined;
  megaMenuItem: MegaMenuItemType;
};

const initialState: NavigationStoreType = {
  activeHref: "",
  activeMenuItem: undefined,
  megaMenuItem: "",
};

export const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    setActiveMenu(
      state: NavigationStoreType,
      action: PayloadAction<{
        activeHref: string;
        activeMenuItem: IMenu;
        megaMenuItem: MegaMenuItemType;
      }>
    ) {
      state.activeMenuItem = action.payload.activeMenuItem;
      state.activeHref = action.payload.activeHref;
      state.megaMenuItem = action.payload.megaMenuItem;
    },
  },
});

export const { setActiveMenu } = navigationSlice.actions;

export default navigationSlice.reducer;
